interface AnalyticsDirectiveTracker {
    trackFormStart(event: { formName: string }): void;
    trackFormSubmit(event: { formName: string; status: string }): void;
    trackButtonClick(event: { buttonName: string }): void;
    trackTabSwitch(event: { tabName: string }): void;
}

const FORM_CLEANUP_KEY = '__tmsAnalyticsFormCleanup__';
const BUTTON_CLEANUP_KEY = '__tmsAnalyticsButtonCleanup__';
const TAB_CLEANUP_KEY = '__tmsAnalyticsTabCleanup__';

function bindingName(value: any, fallback: string): string {
    return typeof value === 'string' && value.trim() ? value.trim() : fallback;
}

export function createAnalyticsDirectives(tracker: AnalyticsDirectiveTracker) {
    return {
        form: {
            bind(element: HTMLElement, binding: { value?: any }) {
                const formName = bindingName(binding.value, 'form');
                let started = false;
                const onStart = () => {
                    if (started) {
                        return;
                    }
                    started = true;
                    tracker.trackFormStart({ formName });
                };
                const onSubmit = () => tracker.trackFormSubmit({
                    formName,
                    status: 'attempted',
                });

                element.addEventListener('input', onStart);
                element.addEventListener('change', onStart);
                element.addEventListener('submit', onSubmit);
                (element as any)[FORM_CLEANUP_KEY] = () => {
                    element.removeEventListener('input', onStart);
                    element.removeEventListener('change', onStart);
                    element.removeEventListener('submit', onSubmit);
                };
            },
            unbind(element: HTMLElement) {
                const cleanup = (element as any)[FORM_CLEANUP_KEY];
                if (cleanup) {
                    cleanup();
                    delete (element as any)[FORM_CLEANUP_KEY];
                }
            },
        },
        button: {
            bind(element: HTMLElement, binding: { value?: any }) {
                const buttonName = bindingName(binding.value, 'button');
                const onClick = () => tracker.trackButtonClick({ buttonName });
                element.addEventListener('click', onClick);
                (element as any)[BUTTON_CLEANUP_KEY] = () => {
                    element.removeEventListener('click', onClick);
                };
            },
            unbind(element: HTMLElement) {
                const cleanup = (element as any)[BUTTON_CLEANUP_KEY];
                if (cleanup) {
                    cleanup();
                    delete (element as any)[BUTTON_CLEANUP_KEY];
                }
            },
        },
        tab: {
            bind(element: HTMLElement, binding: { value?: any }) {
                const tabName = bindingName(binding.value, 'tab');
                const onClick = () => tracker.trackTabSwitch({ tabName });
                element.addEventListener('click', onClick);
                (element as any)[TAB_CLEANUP_KEY] = () => {
                    element.removeEventListener('click', onClick);
                };
            },
            unbind(element: HTMLElement) {
                const cleanup = (element as any)[TAB_CLEANUP_KEY];
                if (cleanup) {
                    cleanup();
                    delete (element as any)[TAB_CLEANUP_KEY];
                }
            },
        },
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/directives/analytics.ts